import CourseController from '../../../../../components/diagrams/course.controller';

class graspingTheMessageController extends CourseController {
  constructor(courseService, helperService, $sce, $scope) {
    "ngInject";
    super(courseService, helperService, $sce, $scope);
    Object.assign(this, { courseService, helperService, $sce });
    this.videoUrl1 = this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322207200');
    this.videoUrl2 = this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322207207');
    this.isUnit = true
    this.exerciseIdsStart = 'diagram1d1-'
  }
}

export default graspingTheMessageController;



// WEBPACK FOOTER //
// ./client/app/modules/courses/1/1d/graspingTheMessage/graspingTheMessage.controller.js